module.exports = __webpack_public_path__ + "img/grey_035.77223045.png";